import DashboardsEdit from '../dashboards/edit/dashboards-edit'
import strategyMapTabs from './strategy-maps-tabs-template'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'

var StrategyMapsEdit = DashboardsEdit.extend({
	newModelNameCode: 'strategyMaps.strategyMap.new',
	className: DashboardsEdit.prototype.className + ' strategy-maps-edit',
	tabsTemplate: strategyMapTabs,
	widgetTypes: ['scorecard-bubble', 'perspective', 'image', 'text',
		'shape', 'line'],
	_getLayouts: function() {
		return [{
			value: 'strategy-map',
			title: i18n.get('common.automatic'),
			icon: 'strategy-layout-automatic'
		},{
			value: 'blank',
			title: i18n.get('common.blank'),
			icon: 'layout-blank'
		}]
	},

	_getLayoutInstructions: function() {
		// determine which banner message to display
		let orgData = this.options.orgData
		let numPerspectives = orgData.numPerspectives
		let hasStructure = orgData.numPerspectives && orgData.numPerspectives != 0
		return hasStructure ? i18n.get('strategyMaps.strategyMap.new.instructions', numPerspectives, orgData.numObjectives, highlight(orgData.label))
			: i18n.get('strategyMaps.strategyMap.noStructure.instructions', highlight(orgData.label))
	},

	_setStartingOptions: function() {
		var options = this._getLayouts()
		// #16287 disable automatic layout options when requirements not met
		let hasStructure = this.options.orgData.numPerspectives && this.options.orgData.numPerspectives != 0
		if (!hasStructure) {
			// Disable 'Automatic' and enable/select 'Blank'
			this.editForm.layoutOptions.disable(options[0])
			this.editForm.layoutOptions.enable(options[1])
			this.editForm.layoutOptions.select(options[1].value)
		} else {
			// Select 'Automatic' by default
			this.editForm.layoutOptions.select(options[0].value)
		}
	},

	cannotEditTemplateMessage: function() {
		return i18n.get('strategyMaps.cannotEditStrategyMap')
	},

	cannotEditDirectTemplateMessage: function() {
		return i18n.get('strategyMaps.cannotEditStrategyMapSuffixPrefix')
	}
})

export default StrategyMapsEdit

StrategyMapsEdit.__filename__ = 'strategy-maps/strategy-maps-edit-view.js'
